import DiscountModule from "./discountModule";

class ReservationCost {
    id = null;
    isFixed = null;
    name = null;
    hasDate = null;
    dateFrom = null;
    dateTo = null;
    value = null;
    isPerNight = null;
    isPerPerson = null;
    isPrepareApartment = null;
    rentAmount = null;
    isInBundle = null;
    bundleId = null;
    cZKCurrencyRate = null;
    langPrefix = null;

    constructor(initData) {
        Object.assign(this, initData);
    }
};

class ReservationData {
    nightsNumber = null;
    dateFrom = null;
    dateTo = null;
    apartmentId = null;
    apartmentName = null;
    cityName = null;
    facilityName = null;
    facilityId = null;
    numberOfPeople = null;
    bundleId = null;
    bundleName = null;
    list = [];

    constructor(initialData) {
        Object.assign(this, initialData);
        this.list = [];
        initialData.list.forEach(obj =>
            this.list.push(new ReservationCost(obj))
        );
    }
}

class ReservationItem {
    id = null;
    name = null;
    value = null;
    loyaltyvalue = null;
    nonRefundableValue = null;
    totalValue = null;
    totalLoyaltyValue = null;
    totalNonRefundableValue = null;
    prefixMultiplierOfDays = null;
    prefixMultiplierOfPerson = null;
    currency = null;
    isPerNight = null;
    isPerPerson = null;
    isFixed = null;
    formatValue = null;
    isRental = null;
    isDiscounted = false;
    hasDate = null;
    dateFrom = null;
    dateTo = null;
    isInBundle = null;

    constructor(id, name, value, loyaltyvalue, nonRefundableValue, totalValue, totalLoyaltyValue, totalNonRefundableValue, prefixMultiplierOfDays, prefixMultiplierOfPerson, currency, isPerNight, isPerPerson, isFixed, hasDate,
        formatValue, isRental, isLoyaltyDiscounted = false, dateFrom = null, dateTo = null, isInBundle = false) {
        this.id = id;
        this.name = name;
        this.value = value;
        this.loyaltyvalue = loyaltyvalue;
        this.nonRefundableValue = nonRefundableValue;
        this.totalValue = totalValue;
        this.totalLoyaltyValue = totalLoyaltyValue;
        this.totalNonRefundableValue = totalNonRefundableValue;
        this.prefixMultiplierOfDays = prefixMultiplierOfDays;
        this.prefixMultiplierOfPerson = prefixMultiplierOfPerson;
        this.currency = currency;
        this.isPerNight = isPerNight;
        this.isPerPerson = isPerPerson;
        this.isFixed = isFixed;
        this.formatValue = formatValue;
        this.isRental = isRental;
        this.isLoyaltyDiscounted = isLoyaltyDiscounted;
        this.dateFrom = dateFrom;
        this.dateTo = dateTo;
        this.isInBundle = isInBundle;
        this.hasDate = hasDate;
    }

    render = (isNonRefundable, isBundle, renderCalcDetails, initialData) => {
        let cssClassName = 'rent-item';
        let cssItemClassName = 'cls' + this.id.toString();
        const reservationItem = document.createElement('div');
        reservationItem.classList.add(cssClassName);
        reservationItem.classList.add(cssItemClassName);

        const reservationItemLeft = document.createElement('div');
        reservationItemLeft.classList.add(cssClassName + '__name');

        reservationItemLeft.innerHTML = `${this.name}`;// (${_formatValue(_value)}${_currency})`;
        if (renderCalcDetails) {
            if (this.value !== 0) {
                if (this.isPerNight && this.isPerPerson) {
                    reservationItemLeft.innerHTML = `${this.name} (${this.prefixMultiplierOfDays}x${this.prefixMultiplierOfPerson}x${this.formatValue(this.value)} ${this.currency})`;
                    if (initialData.langPrefix == 'cs' && initialData.cZKCurrencyRate > 0) {
                        reservationItemLeft.innerHTML = `${this.name} (${this.prefixMultiplierOfDays}x${this.prefixMultiplierOfPerson}x${this.formatValue(this.value)} ${this.currency})`
                            + `<br /> (~${this.prefixMultiplierOfDays}x${this.formatValue(this.value / initialData.cZKCurrencyRate)}` + ` CZK)`;
                    }
                } else if (this.isPerNight && !this.isPerPerson) {
                    reservationItemLeft.innerHTML = `${this.name} (${this.prefixMultiplierOfDays}x${this.formatValue(this.value)} ${this.currency})`;
                    if (initialData.langPrefix == 'cs' && initialData.cZKCurrencyRate > 0) {
                        reservationItemLeft.innerHTML = `${this.name} (${this.prefixMultiplierOfDays}x${this.formatValue(this.value)} ${this.currency})`
                            + `<br /> (~${this.prefixMultiplierOfDays}x${this.formatValue(this.value / initialData.cZKCurrencyRate)}` + ` CZK)`;
                    }
                } else if (!this.isPerNight && this.isPerPerson) {
                    reservationItemLeft.innerHTML = `${this.name} (${this.prefixMultiplierOfPerson}x${this.formatValue(this.value)} ${this.currency})`;
                    if (initialData.langPrefix == 'cs' && initialData.cZKCurrencyRate > 0) {
                        reservationItemLeft.innerHTML = `${this.name} (${this.prefixMultiplierOfPerson}x${this.formatValue(this.value)} ${this.currency})`
                            + `<br /> (~${this.prefixMultiplierOfPerson}x${this.formatValue(this.value / initialData.cZKCurrencyRate)}` + ` CZK)`;
                    }
                }
            }
        }

        if (this.isPerNight && this.dateFrom !== null && this.dateTo !== null && !this.isInBundle) {
            let dtFrom = "";
            let dtTo = "";
            dtFrom = new Date(Date.parse(this.dateFrom));
            dtFrom = ("0" + dtFrom.getDate()).slice(-2) + "-" + ("0" + (dtFrom.getMonth() + 1)).slice(-2) + "-" + dtFrom.getFullYear();
            dtTo = new Date(Date.parse(this.dateTo));
            dtTo = ("0" + dtTo.getDate()).slice(-2) + "-" + ("0" + (dtTo.getMonth() + 1)).slice(-2) + "-" + dtTo.getFullYear();

            if (!this.isFixed) {
                reservationItemLeft.innerHTML = reservationItemLeft.innerHTML + ` <div class="${cssClassName + '__dates'}">${dtFrom} - ${dtTo}</div>`;
            }
        }


        const reservationItemCenter = document.createElement('div');
        reservationItemCenter.classList.add(cssClassName + '__dots');

        const reservationItemRight = document.createElement('div');
        reservationItemRight.classList.add(cssClassName + '__value');
        if (this.isLoyaltyDiscounted || (isNonRefundable && (this.totalNonRefundableValue !== this.totalLoyaltyValue))) {
            reservationItemRight.innerHTML = "<span class='before-discount'>" + `${this.formatValue(this.totalValue)} ${this.currency}` + "</span><br>" + `${this.formatValue(isNonRefundable ? this.totalNonRefundableValue : this.totalLoyaltyValue)} ${this.currency}`;
            if (initialData.langPrefix == 'cs' && initialData.cZKCurrencyRate > 0) {
                reservationItemRight.innerHTML = "<span class='before-discount'>" + `${this.formatValue(this.totalValue)} ${this.currency}` + "</span><br>" + `${this.formatValue(isNonRefundable ? this.totalNonRefundableValue : this.totalLoyaltyValue)} ${this.currency}`
                   + `<br /> (~` + `${this.formatValue(isNonRefundable ? this.totalNonRefundableValue / initialData.cZKCurrencyRate : this.totalLoyaltyValue / initialData.cZKCurrencyRate)}` + ` CZK)`;
            }
        }
        else {
            reservationItemRight.innerHTML = `${this.formatValue(isNonRefundable ? this.totalNonRefundableValue : this.totalLoyaltyValue)} ${this.currency}`;
            if (initialData.langPrefix == 'cs' && initialData.cZKCurrencyRate > 0) {
                reservationItemRight.innerHTML = `${this.formatValue(isNonRefundable ? this.totalNonRefundableValue : this.totalLoyaltyValue)} ${this.currency}`
                    + `<br /> (~` + `${this.formatValue(isNonRefundable ? this.totalNonRefundableValue / initialData.cZKCurrencyRate : this.totalLoyaltyValue / initialData.cZKCurrencyRate)}` + ` CZK)`;
            }
        }

        reservationItem.appendChild(reservationItemLeft);
        if (!isBundle || !this.isInBundle) {
            reservationItem.appendChild(reservationItemCenter);
            reservationItem.appendChild(reservationItemRight);
        }

        return reservationItem;
    }

};


export default class ReservationCalculatorModule {

    settings = null;
    initialData = null;
    locale = null;
    notification = null;
    addons = null;

    residenceCostValue = 0;
    nonRefundableDiscount = 0;
    totalReservationValue = 0;
    rentalNonRefundableDiscountAmount = 0;
    fixedCosts = 0;
    isNonRefundable = false;
    isBundle = false;

    discountApplied = 0;

    reservationData = null;
    reservationItems = [];
    costItems = [];
    otherCostItems = [];
    currentUserIsInLoyaltyProgram = false;
    loyaltyProgramDiscount = 0;

    isUsed = false;
    value = 0;
    valueProcentage = 0;
    isTotalDiscount = false;
    container = document.querySelector('.discount-code');
    totalValueContainer = document.querySelector('.summary p:last-child');
    nonRefundableOffer = document.querySelector('.nonrefundableoffer');
    standardTotalValueContainer = document.querySelector('.standardoffer p>span:last-child');
    nonrefundableTotalValueContainer = document.querySelector('.nonrefundableoffer p>span:last-child');
    bundleTotalValueContainer = document.querySelector('.bundleoffer p>span:last-child');
    bundleSummaryPrice = document.querySelector('.bundle-summary-price');
    advanceAmount = document.querySelectorAll('.advance-amount');
    restAmount = document.querySelectorAll('.rest-amount');
    wholeAmount = document.querySelector('.whole-amount');
    offerDescTitle = document.getElementById('offerDescTitle');
    offerDescPaymentRest = document.querySelectorAll('.rest-amount-desc');

    constructor(settings, initialData, locale, notification, addons) {
        this.reservationItems = [];
        this.costItems = [];
        this.otherCostItems = [];
        this.settings = settings;
        this.currentUserIsInLoyaltyProgram = this.settings.currentUserIsInLoyaltyProgram === 'true' ? true : false;
        this.initialData = initialData;
        this.isBundle = this.initialData.bundleId !== null;
        this.locale = locale;
        this.notification = notification;
        this.addons = addons;
        this.discountModule = new DiscountModule(
            this.locale,
            this.settings,
            this.notification,
            this,
            this.initialData.discountModuleDisabled
        );
        this.prepareCalculations();
        this.reservationData = new ReservationData(initialData);
    }

    recalculateReservationCosts = () => {
        const { initialData, addons } = this;
        const elementsToChange = document.querySelectorAll(`.apartment-reservation div[data-id]`);

        this.totalReservationValue = 0;
        elementsToChange.forEach(element => {
            const itemId = parseInt(element.dataset.id);

            let item = null;
            initialData.list.forEach(initItem => {
                if (initItem.id === itemId) {
                    item = initItem;
                }
            });

            if (item === null) {
                addons.forEach(addon => {
                    if (addon.id === itemId) {
                        item = addon;
                    }
                });
            } 

            // element.remove();
            this.setCalculationItem(item);
        });
    }

    renderRentItems = () => {
        const { initialData } = this;
        let isNonRefundable = this.isNonRefundable;
        const rentListContainer = document.querySelector('.rent-summary-list__container');
        const apartmentReservationList = document.querySelector('.apartment-reservation__list');
        const rentSUmmaryList = document.querySelector('.rent-summary-list');
        const summary = document.querySelector('.summary');

        while (rentListContainer.lastElementChild) {
            rentListContainer.removeChild(rentListContainer.lastElementChild);
        }
        this.costItems.forEach(ri => {
            const el = document.querySelector('.cls' + ri.id.toString());
            if (el !== null) el.parentNode.removeChild(el);
        });
        this.otherCostItems.forEach(ri => {
            const el = document.querySelector('.cls' + ri.id.toString());
            if (el !== null) el.parentNode.removeChild(el);
        });
        this.reservationItems.forEach(ri => {
            rentListContainer.appendChild(ri.render(isNonRefundable, this.isBundle, true, initialData));
        });
        this.costItems.forEach(ri => {
            apartmentReservationList.insertBefore(ri.render(isNonRefundable, this.isBundle, false, initialData), rentSUmmaryList);
        });
        this.otherCostItems.forEach(ri => {
            apartmentReservationList.insertBefore(ri.render(isNonRefundable, this.isBundle, true, initialData), summary);
        });
    }

    getNonRefundableDiscount = () => {
        const { initialData } = this;
        const daysToStart = this.dateDiffInDays(new Date(), new Date(Date.parse(initialData.dateFrom)));
        if (daysToStart > 5) {
            if (initialData.facilityId != 451 && initialData.facilityId != 882) {
                return 0.05;
            }
        }
        return 0;
    }
    isNonRefundableOfferEnabled = () => {
        if (this.isBundle) {
            return false;
        }
        let nonRefundableDiscount = this.getNonRefundableDiscount();
        if (nonRefundableDiscount !== 0) 
        {
            return true;
        }
        return false;
    }
    setCalculationItem = (itemData, toRemove = false, prepareApartmentItem = null) => {
        const { initialData } = this;
        const { OPERATION_PLUS, OPERATION_MINUS, currency, currentUserIsInLoyaltyProgram } = this.settings;
        const { rentalValueName } = this.settings;
        const { bundleStr } = this.settings;
        const countOfPerson = document.querySelector('select[name="countOfPerson"]');
        let loyaltyProgramDiscount = 0;

        if (this.currentUserIsInLoyaltyProgram) {
            loyaltyProgramDiscount = this.settings.loyaltyProgramDiscount;
        }
        
        let totalValue = 0;
        let initialTotalValue = 0;
        let prefixMultiplierOfDays = 1;
        let prefixMultiplierOfPerson = 1;

        //liczenie dni i zapisanie do prefixa
        if (itemData.isPerNight) {
            if (itemData.hasDate) {
                if (Date.parse(itemData.dateFrom) >= Date.parse(initialData.dateFrom) && Date.parse(itemData.dateTo) < Date.parse(initialData.dateTo)) {
                    prefixMultiplierOfDays = this.dateDiffInDays(new Date(Date.parse(itemData.dateFrom)), new Date(Date.parse(itemData.dateTo)))+1;//Dodajemy 1 dzień, gdyż pakiet daje tylko dzień rozpoczęcia
                } else if (Date.parse(itemData.dateFrom) > Date.parse(initialData.dateFrom) && Date.parse(itemData.dateTo) >= Date.parse(initialData.dateTo)) {
                    prefixMultiplierOfDays = this.dateDiffInDays(new Date(Date.parse(itemData.dateFrom)), new Date(Date.parse(initialData.dateTo)));//Nie dodajemy 1 dnia, gdyż data zakończenia rezerwacji już go zawiera
                } else if (Date.parse(itemData.dateFrom) <= Date.parse(initialData.dateFrom) && Date.parse(itemData.dateTo) < Date.parse(initialData.dateTo)) {
                    prefixMultiplierOfDays = this.dateDiffInDays(new Date(Date.parse(initialData.dateFrom)), new Date(Date.parse(itemData.dateTo))) + 1;//Dodajemy 1 dzień, gdyż pakiet daje tylko dzień rozpoczęcia
                } else {
                    prefixMultiplierOfDays = this.dateDiffInDays(new Date(Date.parse(initialData.dateFrom)), new Date(Date.parse(initialData.dateTo)));//Nie dodajemy 1 dnia, gdyż data zakończenia rezerwacji już go zawiera
                }
            } else {
                prefixMultiplierOfDays = initialData.nightsNumber;
            }
        }
        //przeliczenie przez osoby
        if (itemData.isPerPerson) {
            prefixMultiplierOfPerson = countOfPerson.value;
        }
        //obliczenie wartośći
        totalValue = itemData.value * prefixMultiplierOfDays * prefixMultiplierOfPerson;
        if ((itemData.isPrepareApartment === true) || (itemData.id == 2)) {
            initialTotalValue = itemData.initialValue * prefixMultiplierOfDays * prefixMultiplierOfPerson;
            if ((itemData.id == 2)) {
                initialTotalValue = itemData.rentAmount;
            }
        }

        if (toRemove) {
            this.fixedCosts -= Math.ceil(totalValue);
            let toRemoveItemIndex = this.otherCostItems.findIndex((element) => element.id == itemData.id);
            if (toRemoveItemIndex != -1) {
                this.otherCostItems.splice(toRemoveItemIndex, 1);
            }
            const el = document.querySelector('.cls' + itemData.id.toString());
            if (el !== null) el.parentNode.removeChild(el);
            this.updateTotalReservationValue(totalValue, OPERATION_MINUS);
        }
        else
        {
            let addedCostsInput = document.getElementById('AddedCosts');
            if (itemData.id != 1 && itemData.id != 2) {
                addedCostsInput.value += `${itemData.id},`;
            }

            if ((itemData.id !== 2) && (itemData.isPrepareApartment !== true)) {
                this.fixedCosts += Math.ceil(totalValue);
            } else {
                if (itemData.id == 2) {
                    this.residenceCostValue += Math.ceil(initialTotalValue);
                }
                if (itemData.isPrepareApartment === true) {
                    this.fixedCosts += Math.ceil(initialTotalValue);
                }
            }

            var cRIValue = itemData.value;
            var cRITotalValue = totalValue;
            var cRIId = itemData.id;
            if (itemData.isRental === true)
            {
                let stayTotalNonRefundableValue = cRIValue;
                let stayNonRefundableValue = cRITotalValue;
                let stayTotalLoyaltyNonRefundableValue = cRIValue;
                let stayLoyaltyValue = cRITotalValue;
                this.nonRefundableDiscount = this.getNonRefundableDiscount();
                if (prepareApartmentItem !== null) {
                    let nonRefundableDiscountAmount = Math.round(initialTotalValue * this.nonRefundableDiscount * 100) / 100;
                    let loyaltyProgramNonRefDiscountAmount = Math.round((initialTotalValue - nonRefundableDiscountAmount) * loyaltyProgramDiscount / 100 * 100) / 100;
                    stayTotalNonRefundableValue = initialTotalValue - nonRefundableDiscountAmount - loyaltyProgramNonRefDiscountAmount + prepareApartmentItem.initialValue;
                    stayNonRefundableValue = stayTotalNonRefundableValue / initialData.nightsNumber;
                    //let loyaltyProgramDiscountAmount = Math.round(initialTotalValue * loyaltyProgramDiscount / 100 * 100) / 100;
                    let loyaltyProgramDiscountAmount = Math.round(this.initialData.rentAmount * loyaltyProgramDiscount / 100 * 100) / 100;
                    stayTotalLoyaltyNonRefundableValue = initialTotalValue - loyaltyProgramDiscountAmount + prepareApartmentItem.initialValue;
                    stayLoyaltyValue = stayTotalLoyaltyNonRefundableValue / initialData.nightsNumber;
                }
                let isLoyaltyDiscounted = (loyaltyProgramDiscount !== 0 && this.currentUserIsInLoyaltyProgram);
                let mainCostItemName = itemData.name;
                if (initialData.bundleId !== null) {
                    mainCostItemName = initialData.bundleName;
                }
                this.costItems.push(new ReservationItem(cRIId, mainCostItemName,
                    (initialTotalValue /* * (1 - loyaltyProgramDiscount / 100)*/ + prepareApartmentItem.initialValue) / initialData.nightsNumber, stayLoyaltyValue, stayNonRefundableValue,
                    initialTotalValue /* * (1 - loyaltyProgramDiscount / 100)*/ + prepareApartmentItem.initialValue, stayTotalLoyaltyNonRefundableValue, stayTotalNonRefundableValue,
                    prefixMultiplierOfDays, prefixMultiplierOfPerson, currency, itemData.isPerNight, itemData.isPerPerson, itemData.isFixed, itemData.hasDate, this.formatValue, true, isLoyaltyDiscounted));
                this.reservationItems.push(new ReservationItem(cRIId, rentalValueName,
                    itemData.initialValue/* * (1 - loyaltyProgramDiscount / 100)*/, itemData.initialValue * (1 - loyaltyProgramDiscount / 100), itemData.initialValue * (1 - this.nonRefundableDiscount) * (1 - loyaltyProgramDiscount / 100),
                    initialTotalValue/* * (1 - loyaltyProgramDiscount / 100)*/, initialTotalValue * (1 - loyaltyProgramDiscount / 100), initialTotalValue * (1 - this.nonRefundableDiscount) * (1 - loyaltyProgramDiscount / 100),
                    prefixMultiplierOfDays, prefixMultiplierOfPerson, currency, itemData.isPerNight, itemData.isPerPerson, itemData.isFixed, itemData.hasDate, this.formatValue, true, isLoyaltyDiscounted, null, null, (initialData.bundleId !== null)));

                //let loyaltyProgramDiscountAmount = Math.round(initialTotalValue * loyaltyProgramDiscount / 100 * 100) / 100;
                 let loyaltyProgramDiscountAmount = Math.round(this.initialData.rentAmount * loyaltyProgramDiscount / 100 * 100) / 100;
                this.rentalNonRefundableDiscountAmount = (initialTotalValue - loyaltyProgramDiscountAmount) * this.nonRefundableDiscount;
                totalValue = initialTotalValue - loyaltyProgramDiscountAmount + prepareApartmentItem.initialValue;

            }
            else if (itemData.isPrepareApartment === true)
            {
                this.reservationItems.push(new ReservationItem(cRIId, itemData.name,
                    itemData.initialValue, itemData.initialValue, itemData.initialValue, 
                    initialTotalValue, initialTotalValue, initialTotalValue,
                    prefixMultiplierOfDays, prefixMultiplierOfPerson, currency, itemData.isPerNight, itemData.isPerPerson, itemData.isFixed, itemData.hasDate, this.formatValue, false, false, null, null, (initialData.bundleId !== null)));
            } else {
                if ((initialData.bundleId !== null) && (itemData.isInBundle)) {
                    this.reservationItems.push(new ReservationItem(cRIId, itemData.name,
                        cRIValue, cRIValue, cRIValue,
                        cRITotalValue, cRITotalValue, cRITotalValue,
                        prefixMultiplierOfDays, prefixMultiplierOfPerson, currency, itemData.isPerNight, itemData.isPerPerson, itemData.isFixed, itemData.hasDate, this.formatValue, false, false, itemData.dateFrom, itemData.dateTo, itemData.isInBundle));
                } else {
                    this.otherCostItems.push(new ReservationItem(cRIId, itemData.name,
                        cRIValue, cRIValue, cRIValue,
                        cRITotalValue, cRITotalValue, cRITotalValue,
                        prefixMultiplierOfDays, prefixMultiplierOfPerson, currency, itemData.isPerNight, itemData.isPerPerson, itemData.isFixed, itemData.hasDate, this.formatValue, false, false, itemData.dateFrom, itemData.dateTo, false));
                }
            }

            this.updateTotalReservationValue(totalValue, OPERATION_PLUS);
            this.calculateReservationCost();
        }
    }

    removeCalculationItem = (itemId,) => {
        const { OPERATION_MINUS } = this.settings;
        const container = document.querySelector(`.apartment-reservation div[data-id="${itemId}"]`);
        const value = container.dataset.value;

        let addedCostsInput = document.getElementById('AddedCosts');
        if (addedCostsInput.value.includes(itemId)) {
            addedCostsInput.value = addedCostsInput.value.replace(itemId + ',', '');
        }

        container.remove();
        this.updateTotalReservationValue(value, OPERATION_MINUS);
    }

    updateTotalReservationValue = (value, operation) => {
        const { OPERATION_PLUS, OPERATION_MINUS } = this.settings;

        switch (operation) {
            case OPERATION_PLUS:
                this.totalReservationValue += value;
                break;
            case OPERATION_MINUS:
                this.totalReservationValue -= value;
                break;
            default:
                console.error('Unknown operation value!');
        }

        this.calculateReservationCost();
    }

    prepareCalculations = () => {
        const { initialData } = this;

        var transformedList = [];
        var transformedListNonRental = [];
        var rentalItem = null;
        var prepareApartmentItem = null;
        initialData.list.forEach(item => {
            if (item.id === 2) {
                rentalItem = item;
                rentalItem.isRental = true;
            }
            else if (item.isPrepareApartment === true) {
                prepareApartmentItem = item;
                prepareApartmentItem.isPrepareApartment = true;
            }
            else
            {
                transformedListNonRental.push(item);
            }
        });
        if (prepareApartmentItem != null) {
            if (rentalItem != null) {
                rentalItem.initialValue = rentalItem.value;
                rentalItem.value += (prepareApartmentItem.value / initialData.nightsNumber);
                prepareApartmentItem.initialValue = prepareApartmentItem.value;
                prepareApartmentItem.value = 0;
            }
        }
        transformedList = transformedListNonRental;
        if (rentalItem != null) {
            transformedList.push(rentalItem);
        }
        if (prepareApartmentItem != null) {
            transformedList.push(prepareApartmentItem);
        }
        this.residenceCostValue = 0;
        transformedList.forEach(item => {
            this.setCalculationItem(item, false, prepareApartmentItem);
        });
        this.renderRentItems();
    }

    calculateReservationCost = () => {
        const { currency } = this.settings;
        const { value, valueProcentage, isTotalDiscount } = this;
        const discountAppliedDIV = document.getElementById("discount-applied");
        let totalCost = this.totalReservationValue;
        let totalCostNonRef = this.totalReservationValue;
        let initialTotalCost = totalCost;
        const loyalty_program_box = document.querySelector('.loyalty-program__discount');
        const loyaltyProgramDiscount = this.settings.loyaltyProgramDiscount;
        const { initialData } = this;

        let _residenceCostValue = this.residenceCostValue
        let priceOfResidence = this.residenceCostValue;
        let priceOfResidenceNonRef = this.residenceCostValue - Math.round(this.residenceCostValue * this.nonRefundableDiscount * 100) / 100;
        if (loyaltyProgramDiscount !== 0 && loyalty_program_box !== null && this.currentUserIsInLoyaltyProgram) {
            priceOfResidence = priceOfResidence - Math.round(priceOfResidence * loyaltyProgramDiscount / 100 * 100) / 100;
            priceOfResidenceNonRef = priceOfResidenceNonRef - Math.round(priceOfResidenceNonRef * loyaltyProgramDiscount / 100 * 100) / 100;
        }
        totalCostNonRef = priceOfResidenceNonRef + this.fixedCosts;

        if (this.isUsed) {
            if (!isTotalDiscount) {
                if (value !== 0) {
                    let residencePrice = priceOfResidence - value;
                    let residencePriceNonRef = priceOfResidenceNonRef - value;
                    if (residencePrice <= 0) {
                        totalCost = this.fixedCosts;
                    } else {
                        totalCost = residencePrice + this.fixedCosts;
                    }
                    if (residencePriceNonRef <= 0) {
                        totalCostNonRef = this.fixedCosts;
                    } else {
                        totalCostNonRef = residencePriceNonRef + this.fixedCosts;
                    }
                } else if (valueProcentage !== 0) {
                    totalCost = priceOfResidence - Math.round(priceOfResidence * valueProcentage * 100) / 100 + this.fixedCosts;
                    let prcDiscountAmount = this.calculatePercentDiscount(priceOfResidenceNonRef, valueProcentage);
/*                    let prcDiscountMult = Math.trunc(priceOfResidenceNonRef * valueProcentage * 10000);
                    let lastDigits = prcDiscountMult % 100;
                    let prcDiscountAmount = Math.round(priceOfResidenceNonRef * valueProcentage * 100) / 100;
                    if (lastDigits === 50) {
                        prcDiscountAmount -= 0.01;
                    }*/
                    totalCostNonRef = priceOfResidenceNonRef - prcDiscountAmount + this.fixedCosts;
                }
            } else {
                if (value !== 0) {
                    totalCost -= value;
                    totalCostNonRef -= value;
                } else if (valueProcentage !== 0) {
                    let discountValue = Math.round((priceOfResidence + this.fixedCosts) * valueProcentage * 100) / 100;
                    totalCost -= discountValue;
                    let discountValueNonRef = Math.round((priceOfResidenceNonRef + this.fixedCosts) * valueProcentage * 100) / 100;
                    totalCostNonRef -= discountValueNonRef;
                }
            }
        }
        this.discountApplied = totalCost - initialTotalCost;
        let discountAppliedNonRefundable = - (priceOfResidenceNonRef + this.fixedCosts - totalCostNonRef);
        if (this.isUsed && (value !== 0)) {
            discountAppliedNonRefundable = -value;
        }

        if (discountAppliedDIV !== null) {
            if (this.isUsed && this.discountApplied !== 0) {
                discountAppliedDIV.style.display = "block";
                if (this.isNonRefundable) {
                    document.getElementById("discount-applied-value_left").innerHTML = `${this.formatValue(discountAppliedNonRefundable)} ${currency}`;
                } else {
                    document.getElementById("discount-applied-value_left").innerHTML = `${this.formatValue(this.discountApplied)} ${currency}`;
                }
            } else {
                discountAppliedDIV.style.display = "none";
            }
        }


        if (loyalty_program_box !== null) {
            const loyalty_program_discount_amount = loyalty_program_box.querySelector('.discount-value > p > b');
            const loyalty_program_discount_value = loyalty_program_box.querySelector('.discount-amount > p > b');

            loyalty_program_discount_amount.innerHTML = `${loyaltyProgramDiscount} %`;

            if (loyaltyProgramDiscount === 0) {
                loyalty_program_discount_value.innerHTML = `${this.formatValue(0)} ${currency}`
            } else {
                let loyaltyProgramDiscountAmount = Math.round(this.initialData.rentAmount * loyaltyProgramDiscount / 100 * 100) / 100;
                loyalty_program_discount_value.innerHTML = `${this.formatValue(loyaltyProgramDiscountAmount)} ${currency}`;
                if (this.initialData.langPrefix == 'cs' && this.initialData.cZKCurrencyRate > 0) {
                    loyalty_program_discount_value.innerHTML = `${this.formatValue(loyaltyProgramDiscountAmount)} ${currency}`
                        + `<br /> (~` + `${this.formatValue(loyaltyProgramDiscountAmount / this.initialData.cZKCurrencyRate)}` + ` CZK)`;
                }
            }
        }

        let displayTotalCostRefundable = totalCost;
        let displayTotalCostNonRefundable = totalCostNonRef;

        if (this.isNonRefundable) {
            this.totalValueContainer.innerHTML = `${this.formatValue(displayTotalCostNonRefundable)} ${currency}`;
            if (this.initialData.langPrefix == 'cs' && this.initialData.cZKCurrencyRate > 0) {
                const csDisplayTotalCostNonRefundable = displayTotalCostNonRefundable / this.initialData.cZKCurrencyRate
                console.log(`else ${displayTotalCostNonRefundable} / ${this.initialData.cZKCurrencyRate} = ${csDisplayTotalCostNonRefundable}`);
                this.totalValueContainer.innerHTML = `${this.formatValue(displayTotalCostNonRefundable)} ${currency}`
                    + `<br /> (~` + `${this.formatValue(displayTotalCostNonRefundable / this.initialData.cZKCurrencyRate)}` + ` CZK)`;
            }          
        }
        else {
            this.totalValueContainer.innerHTML = `${this.formatValue(displayTotalCostRefundable)} ${currency}`;
            if (this.initialData.langPrefix == 'cs' && this.initialData.cZKCurrencyRate > 0) {
                this.totalValueContainer.innerHTML = `${this.formatValue(displayTotalCostRefundable)} ${currency}`
                    + `<br /> (~` + `${this.formatValue(displayTotalCostRefundable / this.initialData.cZKCurrencyRate)}` + ` CZK)`;
            }
        }
        if (this.isBundle) {
            this.bundleTotalValueContainer.innerHTML = `${this.formatValue(displayTotalCostRefundable)} ${currency}`;
            if (this.initialData.langPrefix == 'cs' && this.initialData.cZKCurrencyRate > 0) {
                this.bundleTotalValueContainer.innerHTML = `${this.formatValue(displayTotalCostRefundable)} ${currency}`
                    + `<br /> (~` + `${this.formatValue(displayTotalCostRefundable / this.initialData.cZKCurrencyRate)}` + ` CZK)`;
            }
            if (this.bundleSummaryPrice != null) {
                this.bundleSummaryPrice.innerHTML = `${this.formatValue(displayTotalCostRefundable)} ${currency}`;
                if (this.initialData.langPrefix == 'cs' && this.initialData.cZKCurrencyRate > 0) {
                    this.bundleSummaryPrice.innerHTML = `${this.formatValue(displayTotalCostRefundable)} ${currency}`
                        + `<br /> (~` + `${this.formatValue(displayTotalCostRefundable / this.initialData.cZKCurrencyRate)}` + ` CZK)`;
                }
            }
        } else {
            this.standardTotalValueContainer.innerHTML = `${this.formatValue(displayTotalCostRefundable)} ${currency}`;
            this.nonrefundableTotalValueContainer.innerHTML = `${this.formatValue(displayTotalCostNonRefundable)} ${currency}`;

            if (this.initialData.langPrefix == 'cs' && this.initialData.cZKCurrencyRate > 0) {
                this.standardTotalValueContainer.innerHTML = `${this.formatValue(displayTotalCostRefundable)} ${currency}`
                    + `<br /> (~` + `${this.formatValue(displayTotalCostRefundable / this.initialData.cZKCurrencyRate)}` + ` CZK)`;

                this.nonrefundableTotalValueContainer.innerHTML = `${this.formatValue(displayTotalCostNonRefundable)} ${currency}`
                    + `<br /> (~` + `${this.formatValue(displayTotalCostNonRefundable / this.initialData.cZKCurrencyRate)}` + ` CZK)`;
            }
        }

        this.setOfferInfo(totalCost, totalCost-displayTotalCostNonRefundable, currency);
        return totalCost;
    }

    setOfferInfo = (totalCost, rentalNonRefundableDiscountAmount, currency) => {
        if ((!this.isBundle) && ((this.isNonRefundable) || !this.isNonRefundableOfferEnabled())) {
            if (this.offerDescTitle !== null) {
                if (this.isNonRefundable) {
                    offerDescTitle.innerHTML = this.locale.nonRefundable;
                } else {
                    offerDescTitle.innerHTML = this.locale.standardOffer;
                }
            }
            this.advanceAmount.forEach((item) => {
                item.innerHTML = `${this.formatValue(totalCost - rentalNonRefundableDiscountAmount)} ${currency}`;
                if (this.initialData.langPrefix == 'cs' && this.initialData.cZKCurrencyRate > 0) {
                    item.innerHTML = `${this.formatValue(totalCost - rentalNonRefundableDiscountAmount)} ${currency}`
                        + ` (~` + `${this.formatValue((totalCost - rentalNonRefundableDiscountAmount) / this.initialData.cZKCurrencyRate)} CZK)`;
                }
            });
            this.restAmount.forEach((item) => {
                item.innerHTML = "";
            });
            if (this.wholeAmount !== null) {
                this.wholeAmount.innerHTML = `${this.formatValue(totalCost - rentalNonRefundableDiscountAmount)} ${currency}`;
                if (this.initialData.langPrefix == 'cs' && this.initialData.cZKCurrencyRate > 0) {
                    this.wholeAmount.innerHTML = `${this.formatValue(totalCost - rentalNonRefundableDiscountAmount)} ${currency}`
                        + ` (~` + `${this.formatValue((totalCost - rentalNonRefundableDiscountAmount) / this.initialData.cZKCurrencyRate)} CZK)`;
                }
            }
            this.offerDescPaymentRest.forEach((item) => {
                item.style.display = 'none';
            });
        } else {
            if (this.offerDescTitle !== null) {
                offerDescTitle.innerHTML = this.locale.standardOffer;
            }
            this.advanceAmount.forEach((item) => {
                item.innerHTML = `${this.formatValue(Math.round(totalCost * 0.3 * 100) / 100)} ${currency}`;
                if (this.initialData.langPrefix == 'cs' && this.initialData.cZKCurrencyRate > 0) {
                    item.innerHTML = `${this.formatValue(Math.round(totalCost * 0.3 * 100) / 100)} ${currency}`
                        + ` (~` + `${this.formatValue((Math.round(totalCost * 0.3 * 100) / 100) / this.initialData.cZKCurrencyRate)} CZK)`;
                }
            });
            this.restAmount.forEach((item) => {
                item.innerHTML = `${this.formatValue(totalCost - Math.round(totalCost * 0.3 * 100) / 100)} ${currency}`;
                if (this.initialData.langPrefix == 'cs' && this.initialData.cZKCurrencyRate > 0) {
                    item.innerHTML = `${this.formatValue(totalCost - Math.round(totalCost * 0.3 * 100) / 100)} ${currency}`
                        + ` (~` + `${this.formatValue((totalCost - Math.round(totalCost * 0.3 * 100) / 100) / this.initialData.cZKCurrencyRate)} CZK)`;
                }
            });
            if (this.wholeAmount !== null) {
                this.wholeAmount.innerHTML = `${this.formatValue(totalCost)} ${currency}`;
                if (this.initialData.langPrefix == 'cs' && this.initialData.cZKCurrencyRate > 0) {
                    this.wholeAmount.innerHTML = `${this.formatValue(totalCost)} ${currency}`
                        + ` (~` + `${this.formatValue(totalCost / this.initialData.cZKCurrencyRate)} CZK)`;
                }
            }
            this.offerDescPaymentRest.forEach((item) => {
                item.style.display = '';
            });
        }
    }

    rerender = () => {
        this.renderRentItems();
        this.calculateReservationCost();
    }

    dateDiffInDays = (a, b) => {
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / (1000 * 3600 * 24));
    }

    formatValue = (value) => {
        return value.toFixed(2).replace('.', ',');
    }

    isset = (value) => {
        return !(!value || value === undefined || value === "" || value.length === 0 || value == null || value === null);
    }

    calculatePercentDiscount = (value, percentDiscount) => {
        let prcDiscountMult = Math.trunc(value * percentDiscount * 10000);
        let lastDigits = prcDiscountMult % 100;
        let prcDiscountAmount = Math.round(value * percentDiscount * 100) / 100;
        if (lastDigits === 50) {
            prcDiscountAmount -= 0.01;
        }
        return prcDiscountAmount;

    }
}